import type { DmLevel } from '@change-corgi/middle-end-gql-schema';
import type { TrackingProperties } from '@change-corgi/tracking-properties';

type TrackingDmLevels = NonNullable<TrackingProperties['dm_levels']>;

const DM_LEVEL_MAP: Record<DmLevel, TrackingDmLevels[number]> = {
	LOCAL_CITY_COUNTY: 'local_city_county',
	LOCAL_STATE: 'local_state',
	NATIONAL: 'national',
};

/** Maps `DecisionMakerMetadata.levels` to the `dm_levels` tracking property. */
export function toTrackingDmLevels(levels: readonly DmLevel[]): TrackingDmLevels {
	return levels.map((level) => DM_LEVEL_MAP[level]);
}
